






import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

@Component({})
export default class CenteredSpinner extends Vue
{
}
